import { NetworkType } from '../../../protos/squareup/unifiedeventing/messages/context';
export function getNetworkInfo() {
    // Currently only Chrome OS provides a means of determining the exact type of connection
    // Navigator.connection.effectiveType only (roughly) communicates speed and rtt
    // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/effectiveType
    // cdp-ingest will fill in ip address if the client doesn't provide it
    return {
        type: NetworkType.UNKNOWN_NETWORK,
        ipAddress: '',
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmV0d29yay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jZHAvY29udGV4dC9uZXR3b3JrLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSwyREFBMkQsQ0FBQztBQU94RixNQUFNLFVBQVUsY0FBYztJQUM1Qix3RkFBd0Y7SUFDeEYsK0VBQStFO0lBQy9FLG9GQUFvRjtJQUVwRixzRUFBc0U7SUFDdEUsT0FBTztRQUNMLElBQUksRUFBRSxXQUFXLENBQUMsZUFBZTtRQUNqQyxTQUFTLEVBQUUsRUFBRTtLQUNkLENBQUM7QUFDSixDQUFDIn0=